import React, { useMemo } from 'react';

import dayjs from 'dayjs';
import { Box, Grid, Stack, useTheme } from '@mui/material';

import { ReactComponent as EmptyCalendar } from 'images/calendar/empty-calendar.svg';
import { months } from 'utils/date';
import {
  Container,
  Title,
  NoData,
  Weekdays,
  Weekday,
  Empty,
  SeparatorLine,
  Text,
  MonthDay,
  CalendarContainer,
} from './styles';
import {
  createDaysForCurrentMonth,
  createDaysForNextMonth,
  createDaysForPreviousMonth,
  days,
} from './util';

const PKDCalendar = (props) => {
  const {
    month,
    year,
    highlightedDays,
    impactType,
    colorMapping,
    keyMapping,
    showCalendar = false,
  } = props;
  const theme = useTheme();

  const selectedMonth = dayjs(new Date(year, month - 1, 1));
  const monthName = months[selectedMonth.month()];

  const currentMonthDays = useMemo(
    () => createDaysForCurrentMonth(year, month),
    [year, month]
  );
  const prevMonthDays = useMemo(
    () => createDaysForPreviousMonth(currentMonthDays, month, year),
    [currentMonthDays, year, month]
  );
  let monthDays = [...prevMonthDays, ...currentMonthDays];
  const nextMonthDays = useMemo(
    () => createDaysForNextMonth(month, year, monthDays),
    [currentMonthDays, year, month]
  );
  monthDays = [...prevMonthDays, ...currentMonthDays, ...nextMonthDays];

  const getColors = (day) => {
    const dayValue = highlightedDays?.[impactType]?.[day.dayOfMonth];

    if (day.isCurrentMonth && dayValue)
      return colorMapping[impactType][
        keyMapping?.[impactType]?.(dayValue) ?? dayValue
      ];

    const color = day.isCurrentMonth
      ? theme.palette.primary.black
      : theme.palette.primary.gray9;

    return { color };
  };

  if (
    (!highlightedDays || Object.keys(highlightedDays).length === 0) &&
    !showCalendar
  ) {
    return (
      <Container
        sx={{ width: '100%' }}>
        <Title>
          {monthName} {year}
        </Title>
        <Empty>
          <Stack
            sx={{ marginTop: '-60px' }}>
            <Box
              sx={{ display: 'flex', margin: 'auto' }}>
              <EmptyCalendar />
            </Box>
            <NoData>No data</NoData>
            <Text>No data for this month</Text>
          </Stack>
        </Empty>
      </Container>
    );
  }

  return (
    <CalendarContainer>
      <Title>
        {monthName} {year}
      </Title>
      <Weekdays
        container>
        {days.map((d, index) => (
          <Grid
            key={`${index}${d}`} item xs='1.7'>
            <Weekday>{d}</Weekday>
          </Grid>
        ))}
      </Weekdays>
      <SeparatorLine />
      <Grid
        container spacing={1} sx={{ mb: '30px' }}>
        {monthDays.map((day, index) => (
          <Grid
            key={index}
            item
            xs='1.7'
            sx={{ display: 'flex', justifyContent: 'center' }}>
            <MonthDay
              sx={{ ...getColors(day) }}>{day.dayOfMonth}</MonthDay>
          </Grid>
        ))}
      </Grid>
    </CalendarContainer>
  );
};

export default PKDCalendar;
